const KEY = 'studio_v2_recents_v1';
const MAX_ITEMS = 24;

function readList() {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeList(list) {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch {
    /* ignore quota errors */
  }
}

export function listStudioRecents() {
  return readList();
}

export function touchStudioRecent(item) {
  if (!item?.id || !item?.kind) return;
  const now = Date.now();
  const next = readList().filter((x) => !(x.kind === item.kind && x.id === item.id));
  next.unshift({
    kind: item.kind,
    id: item.id,
    name: item.name || item.id,
    href: item.href || '',
    pinned: Boolean(item.pinned),
    t: now,
  });
  writeList(next.slice(0, MAX_ITEMS));
}

export function toggleStudioRecentPin(kind, id) {
  const next = readList().map((x) => (
    x.kind === kind && x.id === id ? { ...x, pinned: !x.pinned } : x
  ));
  writeList(next);
  return next;
}
